import axios from "axios";
import React, { useEffect, useState } from "react";

import {
  Button,
  Icon,
  Image,
  Loader,
  Modal,
  ModalContent,
  ModalHeader,
  Tab,
} from "semantic-ui-react";
import PollEditableField from ".././pollEditableField";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";
import css from "../../../assets/styles/shared/editor.module.scss";

const Gifs = (props) => {
  const [option, setOption] = useState("trending");
  const [searchGif, setSearchGif] = useState("");
  const [gifs, setGifs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTrendingGifs = async (searchOption) => {
    try {
      setLoading(true);
      if (option || searchOption) {
        const response = await axios.get(
          `https://api.giphy.com/${option === "emoji" ? "v2" : "v1/gifs"}/${
            searchOption || option
          }`,
          {
            params: {
              api_key: process.env.REACT_APP_GIPHY_API_KEY,
              q: searchGif,
              limit: 20,
            },
          }
        );
        const result = response.data.data;
        setGifs(result);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching trending GIFs:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrendingGifs();
  }, [option]);

  const tables = [
    { menuItem: "Gif", render: () => setOption("trending") },
    { menuItem: "Emoji", render: () => setOption("emoji") },
  ];

  return (
    <>
      <Modal
        onClose={() => props.setGifsModal(false)}
        onOpen={() => props.setGifsModal(true)}
        open={props.gifsModal}
      >
        <ModalHeader className={pollsCss.modalHeader}>
          <Tab
            menu={{
              secondary: true,
              pointing: true,
              className: pollsCss.modelTabClass,
            }}
            panes={tables}
          />
          <span
            style={{ cursor: "pointer", marginLeft: "20px" }}
            onClick={() => props.setGifsModal(false)}
          >
            <Icon name="close" />
          </span>
        </ModalHeader>
        <ModalContent image className={pollsCss.gifModal}>
         {option === "trending" && <div className={`${pollsCss?.optionsInput} ${pollsCss.searchGif}`}>
            <PollEditableField
              onChange={(value) => {
                setSearchGif(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchTrendingGifs(searchGif ? "search" : "trending")
                }
              }}
              value={searchGif}
              placeholder="Type answer choice"
            />
            <Button
              onClick={() => fetchTrendingGifs(searchGif ? "search" : "trending")}
              className={css?.primaryButton}
            >
              Search
            </Button>
          </div>}
          {option === "random" && (
            <Image
              onClick={() => props.getGifUrl(gifs.images.fixed_height.url)}
              src={gifs?.images?.fixed_height?.url}
              alt={gifs.title}
              size="small"
            />
          )}
            <div className={pollsCss.gifContainer}>
            {loading ? (
              <Loader />
            ) : (
            gifs?.length >= 1 &&
            gifs?.map((gif) => {
              return (
                <Image
                  key={gif.id}
                  onClick={() => props.getGifUrl(gif.images.fixed_height.url)}
                  src={gif.images.fixed_height.url}
                  alt={gif.title}
                  size="small"
                />
              );
              })
            )}
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Gifs;
